// @ts-check

// This file creates a React Context that manages feature flags throughout the app.
// Wraps the entire app to provide feature flags to all components.
// Calls getUserContext() which hits /me endpoint which includes feature flags.
// Stores feature flags in "featureFlags" state.

import React from 'react';
import { AuthContext } from '../auth';
import { getUserContext } from '../services/user-service';

export const FeatureFlags = React.createContext({ featureFlags: {} });

export const FeatureFlagsProvider = ({ children }) => {
  const [featureFlags, setFeatureFlags] = React.useState({});
  const { isAuthenticated } = React.useContext(AuthContext);

  React.useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    (async () => {
      try {
        const data = await getUserContext();
        if (data?.featureFlags) {
          setFeatureFlags(data.featureFlags);
        }
      } catch (err) {
        // Silently handle feature flag loading errors
      }
    })();
  }, [isAuthenticated]);

  return (
    <FeatureFlags.Provider value={{ featureFlags }}>
      {children}
    </FeatureFlags.Provider>
  );
};

export const useFeatureFlags = () => React.useContext(FeatureFlags);
// This hook is a simple API for components to check feature flags.
// Returns boolean - true if flag enabled for user, false if disabled.
// Type-safe - always returns a boolean, never undefined.
export const useFeatureFlag = (flagId) => {
  const { featureFlags = {} } = useFeatureFlags();
  return Boolean(featureFlags[flagId]);
};
